import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  headerBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  logoBox: {
    backgroundColor: '#ff0000',
    width: 60,
    height: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontSize: '16pt',
    fontWeight: 'bold',
  },
  companyText: {
    fontFamily: 'Khmer',
    fontSize: '12pt',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  companySubText: {
    fontFamily: 'Khmer',
    fontSize: '10pt',
    textAlign: 'center',
  },
  titleText: {
    fontFamily: 'Khmer',
    fontSize: '14pt',
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: 15,
  },
  titleSubText: {
    fontFamily: 'Khmer',
    fontSize: '12pt',
    textAlign: 'center',
    fontWeight: 'bold',
  },
});

export function PDFInvoiceHeader() {
  return (
    <View>
      {/* Header */}
      <View style={styles.headerBox}>
        <View style={styles.logoBox}>
          <Text style={{ color: '#fff' }}>L192</Text>
        </View>
      </View>

      <View>
        <Text style={styles.companyText}>លីថល ឌីជីថល (ខេមបូឌា) ឯ.ក.</Text>
        <Text style={styles.companySubText}>Little Digital (Cambodia) Co., Ltd.</Text>
        <Text style={styles.companySubText}>ផ្ទះ ១៩២ ផ្លូវ ៦៣ បឹងកេងកង ១</Text>
        <Text style={styles.companySubText}>#192, Street 63, BKK1</Text>
        <Text style={styles.companySubText}>VATIN: L001-901901576</Text>
        <Text style={styles.titleText}>វិក្កយបត្រ</Text>
        <Text style={styles.titleSubText}>Commercial Invoice</Text>
      </View>
    </View>
  );
}
